import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { ApiMethods } from 'common/enums/api-methods.enum';
import { ApiConfig } from 'common/models/api-service/api-config.model';
// import { PagedRequest } from 'common/models/data/pagedRequest.model';

import { CreateRoleDto, EditRoleDto, RoleDto } from '../models/role-management.model';

const roleManagementApiConfig = {
    /** KEEPING THIS CALL FOR TO ADD IF PAGINATION IS REQUIRED */
    // fetchAllApplicationRoles: (payload: PagedRequest): ApiConfig =>
    //     new ApiConfig(
    //         `${CONTROLLER.APPLICATIONROLE}/${METHOD.APPLICATIONROLE.APPLICATION_ROLES}`,
    //         ApiMethods.POST,
    //         '',
    //         payload
    //     ),

    fetchAllApplicationRoles: (): ApiConfig =>
        new ApiConfig(`${CONTROLLER.APPLICATIONROLE}/${METHOD.APPLICATIONROLE.ROLE_LIST}`),

    fetchApplicationFeatures: (roleId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.APPLICATIONROLE}/${METHOD.APPLICATIONROLE.APPLICATION_FEATURES}`,
            ApiMethods.GET,
            `applicationRoleId=${roleId}`
        ),
    createApplicationRole: (payload: CreateRoleDto): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.APPLICATIONROLE}/${METHOD.APPLICATIONROLE.CREATE_ROLE}`,
            ApiMethods.POST,
            '',
            payload
        ),
    updateApplicationRole: (payload: EditRoleDto): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.APPLICATIONROLE}/${METHOD.APPLICATIONROLE.UPDATE_ROLE}`,
            ApiMethods.POST,
            '',
            payload
        ),
    deleteApplicationRole: (roleId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.APPLICATIONROLE}/${METHOD.APPLICATIONROLE.DELETE_ROLE}`,
            ApiMethods.POST,
            `applicationRoleId=${roleId}`
        )
};

export default roleManagementApiConfig;
